import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DeleteActionItemAndUpdateMetricsMutationVariables = Types.Exact<{
  data: Types.DeleteActionItemInput;
  filters: Types.GetByIdFilter;
  widgetMetricsFilters?: Types.InputMaybe<Types.ActionItemsFilters>;
}>;


export type DeleteActionItemAndUpdateMetricsMutation = { deleteActionItem?: { success?: boolean | null, widgetFile?: { id: string, widgetMetrics: { metrics: Array<{ icon: string, metric: string, metricType: Types.FileWidgetMetricTypeEnum }> } } | null, actionItems?: Array<{ id: string, totalTimeSpent?: number | null }> | null } | null };


export const DeleteActionItemAndUpdateMetricsDocument = /*#__PURE__*/ gql`
    mutation deleteActionItemAndUpdateMetrics($data: DeleteActionItemInput!, $filters: GetByIdFilter!, $widgetMetricsFilters: ActionItemsFilters) {
  deleteActionItem(data: $data) {
    success
    widgetFile(filters: $filters) {
      id
      widgetMetrics(filters: $widgetMetricsFilters) {
        metrics {
          icon
          metric
          metricType
        }
      }
    }
    actionItems {
      id
      totalTimeSpent
    }
  }
}
    `;

export function useDeleteActionItemAndUpdateMetricsMutation() {
  return Urql.useMutation<DeleteActionItemAndUpdateMetricsMutation, DeleteActionItemAndUpdateMetricsMutationVariables>(DeleteActionItemAndUpdateMetricsDocument);
};